import { create, useStore } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface VerticalMenuState {
  expanded: boolean;
  actions: {
    toggleExpanded: () => void;
    setCollapsed: (collapsed: boolean) => void;
  };
}

const verticalMenuStore = create<VerticalMenuState>()(
  persist(
    (set) => ({
      expanded: true,
      actions: {
        toggleExpanded: () => set((state) => ({ expanded: !state.expanded })),
        setCollapsed: (collapsed: boolean) =>
          set(() => ({ expanded: !collapsed })),
      },
    }),
    {
      name: 'VerticalMenuState',
      partialize: ({ actions: _, ...state }) => state,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export function useVerticalMenuStore() {
  return useStore(verticalMenuStore);
}
